import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function track(event, metadata = {}) {
  try {
    axios.post(`${API}/public/track`, { event, metadata }).catch((err) => { console.error('Track error:', err); });
  } catch (err) { console.error('Track send error:', err); }
}
